<template>
  <div>
    <public-title showBack>集团管理</public-title>
    <div class="bg-white p-5">
      <left-text-border required class="mb-4" leftText="集团名称" v-model="groupInfo.group_name"/>
      <left-text-border required class="mb-4" leftText="联系人名称" v-model="groupInfo.truename"/>
      <left-text-border required class="mb-4" leftText="手机号" type="number" v-model="groupInfo.mobile"/>
      <left-text-border required class="mb-4" leftText="登录密码" type="password" v-model="groupInfo.password"/>
      <left-text-border required class="mb-4" leftText="确认密码" type="password" v-model="groupInfo.password2"/>
      <div class="d-center-start mb-3">
        <left-text leftText="是否禁用" required/>
        <el-radio-group v-model="groupInfo.status">
          <el-radio label="1">否</el-radio>
          <el-radio label="0">是</el-radio>
        </el-radio-group>
      </div>
      <left-text-select required leftText="集团类型" :options="$GVAR.StoreType.slice(0,6)" v-model="groupInfo.type"/>
      <el-button type="success" @click="submitForm" class="mt-3">提交</el-button>
    </div>
  </div>
</template>

<script>
  import { mapActions} from 'vuex'

  export default {
    name: 'addGroup',
    data() {
      return {
        groupInfo:{
          status:'1',
          group_name:'',
          truename:'',
          mobile:'',
          password:'',
          password2:'',
          type:''
        }
      }
    },
    methods:{
      ...mapActions(['addGroup']),
      submitForm() {
        for (let key in this.groupInfo) {
          if (!this.groupInfo[key]) {
            this._alert('*为必填项，请检查表单',null,'error');
            return;
          }
        }
        this._confirm('确定提交表单么？',() => {
          this.addGroup(this.groupInfo);
        })
      }
    }
  }
</script>
